import { TechErrorBoundary } from './components/hoc/TechErrorBoundary';
import { BankAppConfiguration } from './types/sdk';
import { AppAggregateProvider } from './components/providers/AppAggregateProvider';
import { App } from './App';
import { CustomizationState } from './contexts/CustomizationsContext';

interface BankAppProps {
	configuration: BankAppConfiguration;
	customizations: CustomizationState;
}

export const BankApp = ({ configuration, customizations }: BankAppProps) => {
	return (
		<TechErrorBoundary>
			<AppAggregateProvider configuration={configuration} customizations={customizations}>
				<App />
			</AppAggregateProvider>
		</TechErrorBoundary>
	);
};

export default BankApp;
